import { THEME_BODY_CLASSES, THEME_OPTIONS } from './constant';

export const clearThemeFromBody = () => {
  if (typeof document === 'undefined') return;
  document.body.classList.remove(...THEME_BODY_CLASSES);
};

export const applyThemeToBody = (theme) => {
  if (typeof document === 'undefined') return;

  clearThemeFromBody();

  if (!theme || theme === THEME_OPTIONS.DARK) {
    return;
  }

  if (THEME_BODY_CLASSES.includes(theme)) {
    document.body.classList.add(theme);
  }
};
